<template>
<div v-if="isShow">
    <div>
        <header>足あと設定<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
        </header>
        <div id="wrap">
            <div class="porf-area">
                <table>
                    <tr>
                        <td class="b">足あとを残す</td>
                        <td class="right">
                            <div class="switch3"><label class="switch3__label"><input type="checkbox" id="footPrint_setting_chbox" @click="saveFootPrintSetting()" class="switch3__input" /><span class="switch3__content"></span><span class="switch3__circle"></span></label></div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="txt-area">
                <p>足あとを残すをオフにすることによって、お相手のプロフィールを確認した際に、足あとを残さなくなります。</p>
            </div>
        </div>
    </div>
</div>

<alertDialogBottom :active="isAlert">
    変更しました。
</alertDialogBottom>
<div class="loading-screen" style="opacity: 0.6" v-if="isLoading">
    <div class="loader"></div>
</div>
</template>

<script>
import alertDialogBottom from "@/views/components/alertDialogBottom.vue";
import {
    mapGetters
} from "vuex"
export default {
    props: {
        isShow: Boolean
    },
    emits: ['close'],
    components: {
        alertDialogBottom
    },
    data: () => ({
        isGet: true,
        isAlert: false,
        isLoading: false
    }),
    mounted() {
        this.loadFootprintSetting()
    },
    computed: {
        ...mapGetters(["metadata", 'defaultToken']),
    },
    methods: {
        loadFootprintSetting() {
            this.isLoading = true
            this.$store.dispatch('user/userIndex', {
                token: this.defaultToken
            }).then(data => {
                this.isLoading = false
                document.getElementById('footPrint_setting_chbox').checked = parseInt(data.data.enable_footprint);

            }).catch(err => {
                this.isLoading = false
                console.log(err)
            })
        },

        saveFootPrintSetting() {
            let formData = new FormData();
            formData.append('enable_footprint', (document.getElementById('footPrint_setting_chbox').checked) ? 1 : 0);
            formData.append('token', this.defaultToken);

            this.$store.dispatch('user/userUpdate', formData).then(data => {
                // TODO: show notice at bottom
                this.isAlert = false
                setTimeout(() => {
                    //Clear all Timeout
                    let id = window.setTimeout(function() {}, 0);
                    while (id--) {
                        window.clearTimeout(id); // will do nothing if no timeout with id is present
                    }

                    // Show bottom alert
                    this.isAlert = true
                    setTimeout(() => {
                        this.isAlert = false
                    }, 1000)
                }, 50)
            }).catch(err => {
                console.log(err.response.data.message);
            });
        },
    }
}
</script>
